import * as React from 'react';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import {makeStyles} from '@material-ui/core/styles';
import IconButton from '@mui/material/IconButton';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Grid } from '@mui/material';



const bull = (
  <Box
    component="span"
    sx={{ display: 'inline-block', mx: '2px', transform: 'scale(0.8)' }}
  >
    •
  </Box>
);


const AssignCard= (props) => {
  const classes = useStyles();
  return (
    <Box  sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
    <Card className={classes.card} sx={{boxShadow:'lg',py: 1}}>
      <CardContent sx={{py: 1,}}>
        <Typography className={classes.ModuleNum} sx={{color: 'primary.main', lineHeight: 1}}>
        01 Comparison of vowel sounds
        </Typography>
        <Typography className={classes.ModuleName}  sx={{color: 'primary.main'}}>
        Assets: 03
        </Typography>
        <Typography className={classes.cardText} color="primary.main" sx={{borderTop: 1, borderColor: "#D9D9D9", pt:1}}>
        Total Learners: 08
        </Typography>
        <Typography className={classes.cardText} color="primary.main" sx={{}}>
        Total Learners: 04
        </Typography>
        <Typography  className={classes.className} sx={{borderColor: "#C4CBE7", border: 1 }} >
            Due Date: 23 Oct
        </Typography>
      </CardContent>
      <CardActions sx={{justifyContent: 'space-between', py: 0, pb: 1}}>
        <Grid>
            <Typography sx={{color: '#C4CBE7',fontSize: '0.6rem', textAlign: 'left'}}>ENGLISH</Typography>
        </Grid>
        <Grid>
      <IconButton aria-label="Go" size="small" sx={{borderRadius: '50%', backgroundColor:'#FFFFFF', color: '#86CC7D', boxShadow: 2}}>
        <ArrowForwardIosIcon  fontSize="inherit"/>
      </IconButton>
      </Grid>
      </CardActions>
    </Card>
    </Box>
  );
}


const useStyles = makeStyles({
    card: {
      backgroundColor: "#fff",
      width: '9.2rem',
      borderRadius: 17,
      shadowColor: "#000",
      boxShadow: "2rem",
      paddingLeft: 5,
      paddingRight: 5

    },
    ModuleNum: {
      fontSize: '0.9rem',
      textAlign: 'center',
      fontWeight: "900",
    },
    ModuleName: {
      fontSize: '0.8rem',
      textAlign: "center",
      fontWeight: "500",
      paddingBottom: 10,
      paddingTop: 10
    },
    cardText: {
      fontSize: '0.8rem',
      textAlign: "center",
    },
    className: {
      borderRadius: 20,
      textAlign: "center",
      color: '#C4CBE7',
      fontSize: '0.7rem',
      marginTop: 5,
      marginLeft: 5,
      marginRight: 5
    }
  });

export default AssignCard;